// User
export const GET_MPX_USER_INFO = "GET_MPX_USER_INFO"
export const GET_CABLE_USER_INFO = "GET_CABLE_USER_INFO"
export const GET_OPSUI_AUTHORIZE_INFO = "GET_OPSUI_AUTHORIZE_INFO"
export const GET_MVATS_AUTHORIZE_INFO = "GET_MVATS_AUTHORIZE_INFO"
export const GET_MPX_PARENT_ACCOUNT = "GET_MPX_PARENT_ACCOUNT"
export const GET_MPX_SERVICE_REGISTRY = "GET_MPX_SERVICE_REGISTRY"
export const GET_MPX_SUB_ACCOUNTS = "GET_MPX_SUB_ACCOUNTS"

// Providers, Provider Groups
export const GET_PROVIDERS = "GET_PROVIDERS"
export const GET_PROVIDER_GROUPS = "GET_PROVIDER_GROUPS"

// Rule management
export const GET_XPATH_MAPPINGS = "GET_XPATH_MAPPINGS"
export const GET_XPATH_MAPPINGS_LIST = "GET_XPATH_MAPPINGS_LIST"
export const GET_XPATH_MAPPING_KEYS = "GET_XPATH_MAPPING_KEYS"

// Config service
export const GET_GROUPS = "GET_GROUPS"
export const GET_KEY_DETAILS = "GET_KEY_DETAILS"



// WEBPACK FOOTER //
// ./src/store/constants/action-types.js